module.exports = __webpack_public_path__ + "img/aParty_110523_C.e1e4cf79.jpg";